import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Public
export const fetchProducts = async () => {
    const { data } = await api.get("/products");
    return data.products;
};

export const fetchProduct = async (id) => {
    const { data } = await api.get(`/products/${id}`);
    return data;
};

export const getShippingRates = async ({ items, address }) => {
    const { data } = await api.post("/checkout/rates", { items, address });
    return data;
};

export const createCheckoutSession = async ({
    items,
    address,
    shippo_rate_id,
}) => {
    const { data } = await api.post("/checkout/session", {
        items,
        address,
        shippo_rate_id,
        origin_url: window.location.origin,
    });
    return data;
};

export const getCheckoutStatus = async (sessionId) => {
    const { data } = await api.get(`/checkout/status/${sessionId}`);
    return data;
};

export const submitContact = async (payload) => {
    const { data } = await api.post("/contact", payload);
    return data;
};

export const joinWaitlist = async (payload) => {
    const { data } = await api.post("/waitlist", payload);
    return data;
};

// Admin
const ADMIN_TOKEN_KEY = "co_admin_token";

export const setAdminToken = (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t);
export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

const authHeader = () => {
    const t = getAdminToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = async (password) => {
    const { data } = await api.post("/admin/login", { password });
    return data;
};

export const adminListOrders = async () => {
    const { data } = await api.get("/admin/orders", { headers: authHeader() });
    return data.orders;
};

export const adminListAllOrders = async () => {
    const { data } = await api.get("/admin/orders/all", {
        headers: authHeader(),
    });
    return data.orders;
};

export const adminPackingSlipUrl = (sessionId) =>
    `${API}/admin/orders/${sessionId}/packing-slip.pdf`;
